import baseApi from './base';

const fetchAll = () =>
  baseApi.request({
    method: 'get',
    url: '/dictionaries'
  })

const modifyDictionary = data =>
  baseApi.request({
    method: 'patch',
    url: `/dictionaries/${data.id}`,
    data
  })

const createDictionary = data =>
  baseApi.request({
    method: 'post',
    url: '/dictionaries',
    data
  })

const deleteDictionary = id =>
  baseApi.request({
    method: 'delete',
    url: `dictionaries/${id}`
  })

export {
  fetchAll,
  modifyDictionary,
  createDictionary,
  deleteDictionary
}


// WEBPACK FOOTER //
// ./src/api/dictionary.js